export enum CoordFormat {
  SEXADECIMAL = 'SEXADECIMAL',
  DECIMAL = 'DECIMAL',
}
